import { z } from "zod";

import type { GetOrganizationsQuery } from "./gqls";

/** The `kind` column has no DB-level enum; these are the two values the backend accepts. */
export const ORGANIZATION_KINDS = ["business", "consumer"] as const;

export const zOrganizationFormData = z.object({
  name: z.string().min(1),
  shortCode: z.string().min(1),
  kind: z.enum(ORGANIZATION_KINDS),
});
export type OrganizationFormData = z.infer<typeof zOrganizationFormData>;

export type OrganizationRaw = GetOrganizationsQuery["organizations"][number];

/** UI-ready row passed from the container to the table. */
export interface OrganizationRow {
  id: string;
  name: string;
  shortCode: string;
  kind: (typeof ORGANIZATION_KINDS)[number];
  createdAt: string;
  isDeactivated: boolean;
}
